import styles from './AuthError.css'

/** Bejelentkezéskor történő hiba esetén ez a komponens példányosodik. */
export default function AuthError (): HTMLElement {
  return (
    <div className="auth-error-container">
      <h2 className={ styles.error }>
        Hibás felhasználónév és / vagy jelszó!
      </h2>

      <div className={ styles.info }>
        <ul>
          <li>ellenőrizze, hogy a felhasználónév és jelszó mezőkbe helyes adatok kerültek-e</li>
          <li>használja a jelszó mezőnél látható szem ikont, ha látni szeretné mit írt be</li>
        </ul>
      </div>
    </div>
  )
}
